import { Fragment } from "react";
import { Skills } from "./UI/ContentBlocks";
import { TitleButton } from "./UI/Title";
import { Container } from "@mui/material";
import { TeachersAcademy } from "./websiteContent";
import Banner from "./UI/Banner";

const TeacherAcademy = () => {
  const root = TeachersAcademy;
  return (
    <Fragment>
      <Banner />
      <Container fixed>
        <div>
          <section>
            <TitleButton title={root.title.title} />
            <Skills content={root.content} />
          </section>
        </div>
      </Container>
    </Fragment>
  );
};

export default TeacherAcademy;
